import types from "./types";
import deleteactions from "../../../ManageOOP/Resources/Person/store/deleteactions";

export default (
  state = {
    isFetchingStudentList: false,
    studentList: [],
    studentListError: "",

    isFetchingStudentProgramList: false,
    studentProgramList: [],
    studentProgramListError: "",

    isDeletingAttachment: false,
    deletedAttachment: null,
    deletingAttachmentError: "",

    isCreatingStudent: false,
    createdStudent: null,
    createStudentError: "",

    isUpdatingStudent: false,
    updatedStudent: null,
    studentUpdateError: "",

    isDeletingSchoolchildren: false,
    deletedSchoolchildren: null,
    deletingSchoolchildrenError: "",

    isImportingSchoolchildren: false,
    importedSchoolchildren: null,
    importingSchoolchildrenError: "",
  }, action
) => {
  switch (action.type) {
    case types.GET_STUDENT_LIST_REQUEST:
      return {
        ...state,
        isFetchingStudentList: action.isFetchingStudentList
      }

    case types.GET_STUDENT_LIST_COMPLETED:
      return {
        ...state,
        isFetchingStudentList: action.isFetchingStudentList,
        studentList: action.studentList
      }

    case types.GET_STUDENT_LIST_ERROR:
      return {
        ...state,
        isFetchingStudentList: action.isFetchingStudentList,
        studentListError: action.studentListError
      }

    case types.GET_STUDENT_PROGRAM_LIST_REQUEST:
      return {
        ...state,
        isFetchingStudentProgramList: action.isFetchingStudentProgramList
      }

    case types.GET_STUDENT_PROGRAM_LIST_COMPLETED:
      return {
        ...state,
        isFetchingStudentProgramList: action.isFetchingStudentProgramList,
        studentProgramList: action.studentProgramList
      }

    case types.GET_STUDENT_PROGRAM_LIST_ERROR:
      return {
        ...state,
        isFetchingStudentProgramList: action.isFetchingStudentProgramList,
        studentProgramListError: action.studentProgramListError
      }

    case types.CREATE_STUDENT_REQUEST:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent
      }

    case types.CREATE_STUDENT_COMPLETED:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent,
        createdStudent: action.createdStudent
      }

    case types.CREATE_STUDENT_ERROR:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent,
        createStudentError: action.createStudentError
      }

    case types.UPDATE_STUDENT_REQUEST:
      return {
        ...state,
        isUpdatingStudent: action.isUpdatingStudent
      };
    case types.UPDATE_STUDENT_COMPLETED:
      return {
        ...state,
        isUpdatingStudent: action.isUpdatingStudent,
        updatedStudent: action.updatedStudent
      };
    case types.UPDATE_STUDENT_ERROR:
      return {
        ...state,
        isUpdatingStudent: action.isUpdatingStudent,
        studentUpdateError: action.studentUpdateError
      };

    case types.DELETE_SCHOOLCHILDREN_REQUEST:
      return {
        ...state,
        isDeletingSchoolchildren: action.isDeletingSchoolchildren
      };
    case types.DELETE_SCHOOLCHILDREN_COMPLETED:
      return {
        ...state,
        isDeletingSchoolchildren: action.isDeletingSchoolchildren,
        deletedSchoolchildren: action.deletedSchoolchildren
      };
    case types.DELETE_SCHOOLCHILDREN_ERROR:
      return {
        ...state,
        isDeletingSchoolchildren: action.isDeletingSchoolchildren,
        deletingSchoolchildrenError: action.deletingSchoolchildrenError
      };
    case types.IMPORT_SCHOOLCHILDREN_REQUEST:
      return {
        ...state,
        isImportingSchoolchildren: action.isImportingSchoolchildren
      };
    case types.IMPORT_SCHOOLCHILDREN_COMPLETED:
      return {
        ...state,
        isImportingSchoolchildren: action.isImportingSchoolchildren,
        importedSchoolchildren: action.importedSchoolchildren
      };
    case types.IMPORT_SCHOOLCHILDREN_ERROR:
      return {
        ...state,
        isImportingSchoolchildren: action.isImportingSchoolchildren,
        importingSchoolchildrenError: action.importingSchoolchildrenError
      };

    case types.DELETE_FINAL_ATTACHMENT_REQUEST:
      return {
        ...state,
        isDeletingAttachment: action.isDeletingAttachment
      };
    case types.DELETE_FINAL_ATTACHMENT_COMPLETED:
      return {
        ...state,
        isDeletingAttachment: action.isDeletingAttachment,
        deletedAttachment: action.deletedAttachment
      };
    case types.DELETE_FINAL_ATTACHMENT_ERROR:
      return {
        ...state,
        isDeletingAttachment: action.isDeletingAttachment,
        deletingAttachmentError: action.deletingAttachmentError
      };

    default:
      return state;
  }
}
